export const fontWeightVariants = {
  'font-weight': {
    thin: 'font-thin',
    extralight: 'font-extralight',
    light: 'font-light',
    normal: 'font-normal',
    medium: 'font-medium',
    semibold: 'font-semibold',
    bold: 'font-bold',
    extrabold: 'font-extrabold',
    black: 'font-black',
  },
  'font-weight-sm': {
    thin: 'sm:font-thin',
    extralight: 'sm:font-extralight',
    light: 'sm:font-light',
    normal: 'sm:font-normal',
    medium: 'sm:font-medium',
    semibold: 'sm:font-semibold',
    bold: 'sm:font-bold',
    extrabold: 'sm:font-extrabold',
    black: 'sm:font-black',
  },
  'font-weight-md': {
    thin: 'md:font-thin',
    extralight: 'md:font-extralight',
    light: 'md:font-light',
    normal: 'md:font-normal',
    medium: 'md:font-medium',
    semibold: 'md:font-semibold',
    bold: 'md:font-bold',
    extrabold: 'md:font-extrabold',
    black: 'md:font-black',
  },
  'font-weight-lg': {
    thin: 'lg:font-thin',
    extralight: 'lg:font-extralight',
    light: 'lg:font-light',
    normal: 'lg:font-normal',
    medium: 'lg:font-medium',
    semibold: 'lg:font-semibold',
    bold: 'lg:font-bold',
    extrabold: 'lg:font-extrabold',
    black: 'lg:font-black',
  },
  'font-weight-xl': {
    thin: 'xl:font-thin',
    extralight: 'xl:font-extralight',
    light: 'xl:font-light',
    normal: 'xl:font-normal',
    medium: 'xl:font-medium',
    semibold: 'xl:font-semibold',
    bold: 'xl:font-bold',
    extrabold: 'xl:font-extrabold',
    black: 'xl:font-black',
  },
}
